import * as React from 'react';
import { SocialBar, SocialBarProps } from '.';
import {
  Facebook,
  Instagram,
  LinkedIn,
  Pinterest,
  Tumblr,
} from '@wix/wix-ui-icons-common/on-stage';
import { CopyUrlButton } from '../CopyUrlButton';
import { SocialBarIconTestHook } from './consts';

export const SocialBarExample: React.FC<SocialBarProps> = (props) => {
  return (
    <SocialBar {...props}>
      <SocialBar.Icon
        tooltip="Facebook"
        data-hook={SocialBarIconTestHook}
        icon={
          <Facebook href="https://www.facebook.com/sharer/sharer.php?u=wix.com" />
        }
      />
    </SocialBar>
  );
};

export const SocialBarPopulatedExample: React.FC<SocialBarProps> = (props) => {
  return (
    <SocialBar {...props}>
      <SocialBar.Icon
        tooltip="Facebook"
        data-hook={SocialBarIconTestHook}
        icon={
          <Facebook href="https://www.facebook.com/sharer/sharer.php?u=wix.com" />
        }
      />

      <SocialBar.Icon
        tooltip="Instagram"
        icon={<Instagram />}
        data-hook={SocialBarIconTestHook}
        href="https://www.instagram.com/sharer/sharer.php?u=wix.com"
      />

      <SocialBar.Icon
        tooltip="Linkedin"
        icon={<LinkedIn />}
        data-hook={SocialBarIconTestHook}
        href="https://www.linkedin.com/sharer/sharer.php?u=wix.com"
      />

      <SocialBar.Icon
        tooltip="Tumblr"
        icon={<Tumblr />}
        data-hook={SocialBarIconTestHook}
        href="https://www.tumblr.com/sharer/sharer.php?u=wix.com"
      />

      <SocialBar.Icon
        tooltip="Pinterest"
        icon={<Pinterest />}
        data-hook={SocialBarIconTestHook}
        href="https://www.pinterest.com/sharer/sharer.php?u=wix.com"
      />

      <CopyUrlButton
        data-hook={SocialBarIconTestHook}
        tooltipText="Copy Link"
        successText="Link Copied"
        url="https://google.com"
      />
    </SocialBar>
  );
};
